import { useTranslation } from '@unifyapps/i18n/client';
import { useSnackbar } from '@unifyapps/ui/components/Snackbar';
import { useCallback } from 'react';

// Web sibling — the Yellow.ai chat is a native SDK, so opening it on web warns
// the builder. Resolved over `useYellowAI.native.ts` on native.
export function useYellowAI() {
  const { t } = useTranslation();
  const { showSnackbar } = useSnackbar();

  const openChatbot = useCallback(
    (_secureToken?: string) => {
      showSnackbar({ color: 'warning', title: t('common:YellowAINativeOnly') });
    },
    [showSnackbar, t],
  );

  const closeChatbot = useCallback(() => {
    // no-op on web — the chatbot is native-only
  }, []);

  return { openChatbot, closeChatbot };
}
